var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03D47C",
    fillRule: "evenodd",
    d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm5.189-11.085a1.5 1.5 0 0 0-2.378-1.83L8.762 11.35 6.96 9.848a1.5 1.5 0 0 0-1.92 2.304l4.198 3.499 5.951-7.736Z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckmarkCircle;